angular.module('GlobalHelpersModule').filter "allergyReactionString", ->
  (reactions) ->
    reaction_parts = []
    for r in reactions
      reaction_parts.push "#{r.allergy_reaction_title}"
    reaction_parts.join(', ')